import React, {
  Ref,
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  ReactElement,
} from 'react';
import { Trans } from 'react-i18next';

const INITIAL_TAB_INDEX = 0;

export interface StepperRefProps {
  goToNextStep: () => void;
  goToPreviousStep: () => void;
  goToFirstStep: () => void;
  goToStep: (index: number) => void;
}

export interface StepView {
  title?: string;
  component: () => ReactElement;
}

interface Props {
  steps: StepView[];
  onChange?: (index: number) => void;
}

const StepperView = forwardRef(({ steps, onChange }: Props, ref: Ref<StepperRefProps>) => {
  const [step, setStep] = useState<number>(INITIAL_TAB_INDEX);

  useEffect(() => {
    onChange && onChange(step);
  }, [onChange, step]);

  useImperativeHandle(ref, () => ({
    goToNextStep: () => setStep(step + 1),
    goToPreviousStep: () => setStep(step - 1),
    goToFirstStep: () => setStep(INITIAL_TAB_INDEX),
    goToStep: (index: number) => setStep(index),
  }));

  return (
    <>
      {steps[step].title ? (
        <div>
          <Trans i18nKey={steps[step].title} />
        </div>
      ) : null}
      {steps[step].component()}
    </>
  );
});

export default StepperView;
